import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation, useRouteError } from 'react-router-dom';
import { setErrorFlag, setErrorDetails } from './Slice/errorSlice';

import styles from './style.module.css';

const ErrorBoundaryFallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const error = useRouteError();
  const error_obj = useSelector((store) => store.error);
  useEffect(() => {
    const fullUrl = window.location.href;
    console.log('display obj = ', error_obj);
    console.log(`@@@@ stack = `, error?.stack);
    dispatch(
      setErrorDetails({
        errorFlag: true,
        urlPath: fullUrl,
        errorMessage: error?.stack,
      })
    );
    console.log('error details = ', {
      errorFlag: true,
      urlPath: fullUrl,
      errorMessage: error,
    });
    if (process.env.REACT_APP_IS_LOCAL === 'true') {
      return () => undefined;
    }
    const timeout = setTimeout(() => {
      // TODO: change from / to -1
      navigate('/');
    }, 1000);

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div className={`${styles.errorContainer}`}>
      <div className={`${styles.errorHeading}`}>
        An Error Occured. Please wait to be redirected shortly.
      </div>
    </div>
  );
};

export default ErrorBoundaryFallback;
